interface ObjectiveValues {
  objective?: string;
  objective2?: string;
  objective3?: string;
  objective4?: string;
}

export const shouldDisableObjective2 = (values: ObjectiveValues): boolean => {
  const hasValue = Boolean(values.objective2);
  const prerequisitesFilled = Boolean(values.objective);
  return !hasValue && !prerequisitesFilled;
};

export const shouldDisableObjective3 = (values: ObjectiveValues): boolean => {
  const hasValue = Boolean(values.objective3);
  const prerequisitesFilled = Boolean(values.objective && values.objective2);
  return !hasValue && !prerequisitesFilled;
};

export const shouldDisableObjective4 = (values: ObjectiveValues): boolean => {
  const hasValue = Boolean(values.objective4);
  const prerequisitesFilled = Boolean(
    values.objective && values.objective2 && values.objective3,
  );
  return !hasValue && !prerequisitesFilled;
};

export const objectiveFieldHelpers = {
  shouldDisableObjective2,
  shouldDisableObjective3,
  shouldDisableObjective4,
} as const;
